import React from 'react';
import CasaColoresApp from './components/CasaColoresApp';

function App() {
  return (
    <div className="App">
      <CasaColoresApp />
    </div>
  );
}

export default App;
